import { useSubscription } from "@apollo/client";
import { useState } from "react";

import { GET_CUSTOM_FIX_SUBSCRIPTION } from "../../vulnerability-modal/queries";
import { useAudit } from "hooks/use-audit";
import { Logger } from "utils/logger";

interface IUseCustomFix {
  customFixMarkdown: string;
  loading: boolean;
  hasData: boolean;
}

const useCustomFix = (
  vulnId: string,
  isAutoFixable: boolean,
): IUseCustomFix => {
  const { addAuditEvent } = useAudit();

  const [customFixMarkdown, setCustomFixMarkdown] = useState("");
  const [hasData, setHasData] = useState(false);

  const { loading } = useSubscription(GET_CUSTOM_FIX_SUBSCRIPTION, {
    onComplete: (): void => {
      addAuditEvent("Vulnerability.CustomFix", vulnId);
    },
    onData: (options): void => {
      const { data } = options.data;
      if (data !== undefined) {
        setHasData(true);
        setCustomFixMarkdown((previous): string =>
          previous.concat(data.getCustomFix),
        );
      }
    },
    onError: ({ graphQLErrors }): void => {
      graphQLErrors.forEach((error): void => {
        Logger.warning("An error occurred generating the remediation", error);
      });
    },
    skip: !isAutoFixable,
    variables: { vulnId },
  });

  return { customFixMarkdown, hasData, loading };
};

export { useCustomFix };
